import { render, staticRenderFns } from "./existingFilesArea.vue?vue&type=template&id=071da773&lang=pug&"
import script from "./existingFilesArea.vue?vue&type=script&lang=js&"
export * from "./existingFilesArea.vue?vue&type=script&lang=js&"
import style0 from "./existingFilesArea.vue?vue&type=style&index=0&id=071da773&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports